import script from "./NewsPageThemesSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageThemesSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageThemesSwitcher.vue?vue&type=style&index=0&id=0cd9d95a&lang=scss"

const __exports__ = script;

export default __exports__